<template>
  <div class="cell-wrap pointer" :class="textLight ? 'text-light' : ''" @click="$emit('active')">
    <div class="cell-left">{{ textLeft }}</div>
    <div class="cell-right">
      <div>{{ textRight }}</div>
      <fps-icon type="arrow-right" size="20" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    textLeft: String,
    textRight: String,
    textLight: {
      type: Boolean,
      default: true,
    },
    // disable: {
    //   type: Boolean,
    //   default: false,
    // },
  }
}
</script>
<style lang="scss" scoped>
  .cell-wrap {
    width: 100%;
    height: 100%;
    border: 1px solid $color-split;
    border-radius: 8px;
    background: $color-light;
    @include flex(space-between);
    padding: 0 20px;
    font-size: 14px;
    line-height: 14px;
    color: $color-gray-3;
    .cell-right {
      @include flex;
    }
    &.text-light {
      color: $color-gray-1;
    }
  }
</style>
